<template>
  <basic-container id="carMonthManage20220222">
    <avue-crud
      v-if="reWrite"
      :search.sync="searchForm"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      :upload-before="uploadBefore"
      :upload-error="uploadError"
      :upload-after="uploadAfter"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateEndRangeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.expiredTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"

            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.expiredTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"

              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
    </template>
      <template slot="areaName" slot-scope="scope">
        <wq-overHidden :content="scope.row.areaName">
          <span>{{ scope.row.areaName }}</span>
        </wq-overHidden>
      </template>


      <template slot-scope="scope" slot="carNoForm">
        <el-autocomplete
          style="width: 100%"
          v-model="form.carNo"
          :debounce="1000"
          @input="carNohandleBlur"
          placeholder="请输入车牌号"
          :trigger-on-focus="true"
          :disabled="dialogDisabled"
          :fetch-suggestions="queryCarPayMonthCarNo"
          @select="selectCarPayCarNo"
        ></el-autocomplete>
      </template>
      <template slot-scope="scope" slot="spaceIdForm">
        <el-select
          :disabled="dialogDisabled"
          v-model="form.spaceId"
          filterable
          placeholder="请选择停车场"
          style="width: 100%"
          @input="selectSpace"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="invoiceDescription" slot-scope="scope">
        <wq-overHidden :content="scope.row.invoiceDescription">
          <span>{{ scope.row.invoiceDescription }}</span>
        </wq-overHidden>
      </template>

      <template slot="menuLeft">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.quickBtn"
          @click="openCarMonthQuickRegistrationDialog"
          >快速登记
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editPlusBtn"
          @click="openCarMonthEditPlusDialog"
          >高级修改
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editBtnNormal"
          @click="openCarMonthEditPlusNormalDialog"
          >修改
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.plateBtn"
          @click="openCarMonthChangeDialog"
          >车牌变更
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.plateBtn"
          @click="secondCarMainChange"
          >主副车变更
        </el-button>
        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDelete"
          >注 销
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.refundBtn"
          @click="openCarManageRefundDialog"
        >退 款
        </el-button>
        <el-button type="primary" v-if="permission.monthCarImportV3" size="small"  @click="exportCar(1)"
          >导入月卡车
        </el-button>
        <el-button type="primary"  v-if="permission.staticCarImportV3" size="small"  @click="exportCar(2)"
          >导入固定车
        </el-button>
        <el-button type="primary" v-if="permission.valueStorageCarImportV3" size="small"  @click="exportCar(3)"
          >导入储值车
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          v-if="permissionList.exportCarBtn"
          @click="exportCarManageExcel"
        >导出
        </el-button>
<span>&nbsp;&nbsp;&nbsp;</span>
        <span>待审核 {{ statusCountNew.toAuditNum }} </span>
        <span>待付款 {{ statusCountNew.toPayNum }} </span>
        <span>正常 {{ statusCountNew.normalNum }} </span>
        <span>已过期 {{ statusCountNew.expiredNum }} </span>
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button
          size="small"
          type="text"
          icon="el-icon-view"
          @click="openCarMonthViewNormalDialog(scope.row, 1)"
          >查 看
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-view"
          v-if="(scope.row.carManageType == 4 ||scope.row.carManageType == 3 )&& permissionList.payBtn"
          @click="handlePayCarMonth(scope.row, 0, true)"
          >充 值
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-view"
          v-if="scope.row.carStatus == 2 && scope.row.carManageType == 1 && permissionList.payBtn"
          @click="handlePayCarMonth(scope.row, 0)"
          >付 款
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-s-custom"
          v-else-if="scope.row.isMainCar == 1 && scope.row.carStatus != 1 && scope.row.carManageType == 1 && permissionList.contractBtn"
          @click="handlePayCarMonth(scope.row, 1)"
          >续 约
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-s-check"
          v-if="scope.row.carStatus == 1 && permissionList.auditBtn"
          @click="openCarMonthApproveDialog(scope.row)"
          >审 核
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-delete"
          v-if="scope.row.carStatus == 5 && permissionList.delBtn"
          @click="openCarMonthDeleteDialog(scope.row)"
          >删 除
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-delete"
          v-if="scope.row.carStatus == 1 && scope.row.carManageType == 1"
          @click="handleDeleteCarMonth(scope.row, 1)"
          >删 除
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-edit"
          v-if="scope.row.carStatus == 1 && scope.row.carManageType == 1"
          @click="openCarMonthEditNormalDialog(scope.row, 1)"
          >编 辑
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="修改"
      :visible.sync="carMonthEditShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthEditFormRef"
          v-model="carMonthEditForm"
          :option="carMonthEditOption"
          @submit="carMonthEditSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthEditDialog">返回</el-button>
          </template>
          <template slot="discountId">
            <el-select v-model="carMonthEditForm.discountId" clearable="true">
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="carMonthViewShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthViewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthViewFormRef"
          v-model="carMonthViewForm"
          :option="carMonthViewOption"
        >
          <template slot="roomId">
            <el-input readonly disabled="true" v-model="carMonthReviewForm.areaName"> </el-input>
          </template>
          <template slot="info" slot-scope="scope">
            <div>
              <avue-crud :option="infoOption" :data="infoData"></avue-crud>
            </div>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="carMonthReviewShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthReviewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthReviewForm"
          :option="carMonthReviewOption"
          @submit="carMonthReviewSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthReviewDialog">返回</el-button>
          </template>
          <template slot="discountId">
            <el-select v-model="carMonthReviewForm.discountId" clearable="true">
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <el-dialog title="按条件导出" append-to-body :visible.sync="exportExcelFlag">
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>

    <carMonthExport
      ref="carMonthExport"
      v-bind:spaceList="spaceList"
      v-bind:statusList="statusList"
      v-bind:carTypeList="carTypeList"
    >
    </carMonthExport>
    <el-dialog
      title="临停车欠费记录"
      append-to-body
      :visible.sync="tempStopUnPayDialogFlag"
      @closed="closeDialog"
    >
      <avue-crud :option="unPayOption" :data="unPayData" ref="unPayFormRef" />
    </el-dialog>
    <el-dialog :title="payFormTitle" append-to-body :visible.sync="showMonthCarPayFlag">
      <avue-form
        ref="carMonthCardPayForm"
        @submit="genearateQrCode"
        v-if="showMonthCarPayFlag"
        v-model="carMonthCardPayForm"
        :option="carMonthPayFormOption"
      >
          <template slot="payAmount">
            <div>
              <div v-if="carMonthCardPayForm.carManageType==4||carMonthCardPayForm.carManageType==3">
                <moneyInput2
                  v-model="carMonthCardPayForm.payAmount"
                  placeholder="请输入充值金额"
                  style="width: 100%"
                  template="append"
                  @input="payAmountInputChange"
                >
                </moneyInput2>
              </div>
              <div v-else>
                <el-input
                disabled
                  v-model="carMonthCardPayForm.payAmount"
                  placeholder="请输入实缴金额"
                >
                </el-input>
              </div>
            </div>
          </template>

        <template slot="cycleNum">
          <el-select
            :disabled="payFormTitle==='付款'"
           v-model="carMonthCardPayForm.cycleNum" @change="cycleNumChange">
            <el-option
              v-for="item in cycleNumList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="payType">
          <el-select v-model="carMonthCardPayForm.payType" @change="payTypeChange">
            <el-option
              v-for="item in payTypeList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="discountRuleId">
          <el-select
            v-model="carMonthCardPayForm.discountRuleId"
            :disabled="payFormTitle==='付款'"
            clearable="true"
            @change="discountRuleIdChange"
          >
            <el-option
              v-for="item in discountRuleList"
              :key="item.id"
              :label="item.discountName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="feeRuleId">
          <el-select
            v-model="carMonthCardPayForm.feeRuleId"
            :disabled="true"
            clearable="true"

          >
            <el-option
              v-for="item in ruleList"
              :key="item.id"
              :label="item.setmealName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="payScene">
          <el-select v-model="carMonthCardPayForm.payScene" @change="paySceneChange">
            <el-option
              v-for="item in paySceneList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="authCode">
          <el-input
            type="password"
            ref="authCodeInput"
            v-model="carMonthCardPayForm.authCode"
            @blur="blurHandler"
            @input="inputHandler"
            @focus="focusHandler"
            maxlength="18"
            placeholder="请输入收款码"
          ></el-input>
        </template>
      </avue-form>
      <div style="padding: 1rem; overflow: hidden">
        <div style="float: right">
          <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
          <el-button @click="cancelPay" type="normal">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="payInfo2.showQrCode"
      :title="payScene == 6 ? '查询中' : '收款码'"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="roomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthCardPayForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthCardPayForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <!-- </template> -->
        <div style="height: 1rem"></div>
        <!-- <template slot="roomId"> -->
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthCardPayForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <!-- </template> -->
      <!-- </avue-form> -->
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="confirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="reviewRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthReviewForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthReviewForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthReviewForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="reviewConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="房间" append-to-body :visible.sync="editRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthEditForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthEditForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthEditForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="editConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <t-printPreview ref="printPreview"></t-printPreview>
    <el-dialog
      title="导入月卡车"
      :visible.sync="showImportDialog"
      v-if="showImportDialog"
      :modal-append-to-body="false"
      width="600px"
      id="month-car-upload"
    >
      <el-form
        ref="importMonthCarForm"
        :model="importMonthCarForm"
        label-width="150px"
        :rules="importMonthCarFormRules"
      >
        <el-row>
          <el-col span="24">
            <el-form-item label="请选择停车场" prop="parkId" id="importMonthCarForm">
              <el-select
                v-model="importMonthCarForm.parkId"
                filterable
                placeholder="请选择停车场"
                style="width: 90%"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="导入Excel" prop="fileName">
              <el-upload
                accept=".xls, .xlsx"
                limit="1"
                style="display: inline-block; vertical-align: top; width: 100%; height: 60px"
                ref="upload"
                :disabled="selectFileDisabled"
                action=""
                :auto-upload="false"
                :http-request="exportMonthCar"
                :on-success="uploadImgSuccess"
                :on-change="loadJsonFromFile"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary" :disabled="selectFileDisabled"
                  >请选择文件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px">
          <el-col offset="16">
            <el-button
              type="primary"
              :disabled="importButtonDisabled"
              size="small"
              icon="el-icon-check"
              @click="uploadMonthCar"
              style="width: 72px; height: 36px"
              >确认
            </el-button>
            <el-button
              size="small"
              :disabled="importButtonDisabled"
              @click="cancelUploadMonthCar"
              icon="el-icon-close"
              style="width: 72px; height: 36px"
              >取消
            </el-button>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      title="车牌变更"
      :visible.sync="carMonthChangeShowDialogFlag"
      :modal-append-to-body="false"
      @opened="openCarMonthChangeDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthChangeFormRef"
          v-model="carMonthChangeForm"
          :option="carMonthChangeOption"
          @submit="carMonthChangeSubmit"
        >
          <template slot-scope="scope" slot="regions">
            <avue-input-tree
              style="width: 100%"
              :props="treeRegionProps"
              v-model="carMonthChangeForm.regions"
              placeholder="请选择授权区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
              disabled
            ></avue-input-tree>
            </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthChangeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <hr-dialog
      :visible.sync="showMainCarChangeFlag"
      width="60%"
      title="主副车变更"
      operatorModel="add"
    >
      <template slot="body">
        <div>
          <div v-if="subCarList.length>1">
            <div>车牌号【{{mainRow.plateNumber}}】为主车，请选择以下副车变更为主车</div>
            <div>
              <el-radio v-for="(item,index) in subCarList" :key="index" v-model="tempSubCarId" :label="item.id">{{item.plateNumber}}</el-radio>
  <!-- <el-radio v-model="radio" label="2">备选项</el-radio> -->
            </div>
            <div>变更成功后，原主车自动降为副车。</div>
          </div>
          <div v-if="subCarList.length==1">
            <div v-if="mainFlag">车牌号【{{mainRow.plateNumber}}】为主车，原副车【{{subCarList[0].plateNumber}}】将自动升为主车</div>
            <div v-if="!mainFlag">车牌号【{{subCarList[0].plateNumber}}】为副车，升为主车后，原主车【{{mainRow.plateNumber}}】将自动降为副车</div>
          </div>
          <!-- <div></div> -->
        </div>
      </template>
      <template slot="footer">
        <el-button type="primary" @click.stop="saveMainSubChange">保存</el-button>
        <el-button type="default" @click.stop="cancelMainSubChange">取消</el-button>
      </template>
    </hr-dialog>

    <hr-dialog
      :visible.sync="quickRegistrationVisible"
      width="60%"
      title="快速登记"
      operatorModel="add"
    >
      <template slot="body">
        <QuickRegistration
          @success="quickAddSuccess"
          @cancle="quickAddCancle"
          v-if="quickRegistrationVisible"
          v-model="quickRegistrationForm"
        ></QuickRegistration>
      </template>
    </hr-dialog>

    <hr-dialog :visible.sync="editNormalVisible" width="60%" title="编辑" operatorModel="edit">
      <template slot="body">
        <editNormalRecord
          @success="editNormalSuccess"
          @cancel="editNormalCancel"
          v-if="editNormalVisible"
          v-model="editNormalForm"
        >
        </editNormalRecord>
      </template>
    </hr-dialog>


    <hr-dialog :visible.sync="viewNormalVisible" width="60%" title="查看" operatorModel="view">
      <template slot="body">
        <viewNormalRecord
          @success="viewNormalSuccess"
          @cancel="viewNormalCancel"
          v-if="viewNormalVisible"
          v-model="viewNormalForm"
        >
        </viewNormalRecord>
      </template>
    </hr-dialog>
<!--    审核-->
    <hr-dialog :visible.sync="approveVisible" width="60%" title="审核" operatorModel="approve">
      <template slot="body">
        <approveRecord
          @success="approveSuccess"
          @cancel="approveCancel"
          v-if="approveVisible"
          v-model="approveForm"
        >
        </approveRecord>
      </template>
    </hr-dialog>

    <!--    退款-->
    <hr-dialog :visible.sync="refundVisible" width="60%" title="退款" operatorModel="refund">
      <template slot="body">
        <refundRecord
          @success="refundSuccess"
          @cancel="refundCancel"
          v-if="refundVisible"
          v-model="refundForm"
        >
        </refundRecord>
      </template>
    </hr-dialog>

    <hr-dialog :visible.sync="editPlusVisible" width="60%" title="高级修改" operatorModel="edit">
      <template slot="body">
        <editPlusRecord
          @success="editPlusSuccess"
          @cancel="editPlusCancel"
          v-if="editPlusVisible"
          v-model="editPlusForm"
        >
        </editPlusRecord>
      </template>
    </hr-dialog>

    <hr-dialog :visible.sync="editPlusNormalVisible" width="60%" title="修改" operatorModel="edit">
      <template slot="body">
        <editPlusRecordNormal
        @success="editPlusSuccess"
          @cancel="editPlusCancel"
          v-if="editPlusNormalVisible"
          v-model="editPlusForm"
        >
        </editPlusRecordNormal>
      </template>
    </hr-dialog>
    <makeOutAnInvoice ref="makeOutAnInvoice" @onLoad="onLoad"></makeOutAnInvoice>

    <el-dialog
      title="支付处理中..."
      :visible.sync="statusDialogVisible"
      width="30%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :mask="true"
    >
      <div style="text-align: center">{{ statusDuration }}</div>
    </el-dialog>

    <ImportForm
      :exportApi="`/api/v4ward/car/manage/exportTemplate`"
      :submitApi="`/api/v4ward/car/manage/importCar`"
      :spaceId="this.searchForm.spaceId"
      :carManageType ="this.carManageType"
      @success="importSuccess"
      :title="importTitle"
      :visible.sync="isImportDialogShow"
    ></ImportForm>
  </basic-container>
</template>
<script>
import {
  carManagePayQuery,
  carManageCheckPay,
  carManagePay,
  plateNumberChange,
  getList,
  calculateMonthCarFeeInFo,getCarRuleDiscountListNew,
  getCarRuleList,mainSecondChange,removeMainCar,secondCarChangeCheck,
  getManageDetail,getMonthCarFeeInFo,mainCarChangeOrRemoveCheck,getCarManageStatusCount
} from './parkvehicle';
import QRCode from 'qrcodejs2';
import {
  modifyCarMonth,
  auditCarMonth,
} from '@/api/v4ward/carv2/carcharge';
import { getToken } from '@/util/auth';
import { loadZhxx } from '@/api/charge';
import {
  getPayTypeListforSpaceId,
  getPaySceneList,
  loadRoomList,
} from '@/api/chargev2/charge-pay';
import {
  addRenior,
  getDetailAndOperate,
  getcarMonthLastEndTime,
  remove,
  update,
  loadCarPayBackAmount,
  loadCarPayAmount,
  getDetail,
  loadCarPayMonthCarNo,
  nodeTreeByParentId,
  getListTempStopUnPayList,
  exportMonthCarList,
  synchronize,
  synchronizePlus,
} from '@/api/v4ward/carv2/carmonth';
import {
  monthChargeRuleList,
  monthChargeRuleListV2,
  initEndTime,
  carMonthRuleV2,
} from '@/api/v4ward/carv2/carmonthchargerule';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import carMonthRenewOption from './carmonth-renew-option';
import carMonthReviewOption from './carmonth-review-option';
import carMonthEditOption from './carmonth-edit-option';
import carMonthViewOption from './carmonth-view-option';
import exportExcelOption from './carmonth-exportExcel';
import carMonthPayOption from './carmonth-pay-option';
import carMonthChangeOption from './carmonth-change-option-c';
import carMonthRefundOption from './carmonth-refund-option';
import carMonthExport from './carMonthExport';
import carMonthCopyOption from './carmonthRenior-copyCarmonth';
import carMonthPayFormOption from './carmonthCharge.js';
import { getDictionary } from '@/api/common.js';
import dayjs from 'dayjs';
import QuickRegistration from './quickRegistrationRecord.vue'; //快速登记
import editPlusRecord from './editPlusRecord.vue'; //高级修改
import editPlusRecordNormal from './editPlusRecordNormal.vue'; //普通修改
import refundRecord from './refundRecord.vue'; //退款

import editNormalRecord from './editNormalRecord.vue'; //修改
import viewNormalRecord from './viewNormalRecord.vue'; //修改
import approveRecord from './approveRecord.vue'; //审核
import makeOutAnInvoice from './makeOutAnInvoice.vue';
import moneyInput2 from '@/components/money-input2/index.vue';
import ImportForm from "./importForm.vue"
import exportData from "@/components/exportData/exportDataSimple";
export default {
  components: {moneyInput2,
    ImportForm,
    carMonthExport,
    QuickRegistration,
    editPlusRecord,
    editPlusRecordNormal,
    makeOutAnInvoice,
    editNormalRecord,
    viewNormalRecord,
    exportData,
    refundRecord,
    approveRecord},
  data() {
    return {
      editPlusNormalVisible:false,
      importTitle:"月卡车导入",
      isImportDialogShow:false,
      carManageType:"1",
      statusDialogVisible: false,
      statusDuration: 120,
      tempSubCarId:'',
      cycleNumList:[],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },regionList:[],
      subCarList:[],mainRow:{},
      deleteBtnFlag:false,
      mainFlag:false,
      showMainCarChangeFlag:false,
      paySubtnFlag: true,
      editWatchOpen: false,
      reviewWatchOpen: false,
      payWatchOpen: false,
      discountRuleList: [],
      searchForm: {},
      importMonthCarForm: {
        parkId: '',
        fileName: '',
      },
      importMonthCarFormRules: {
        parkId: [{ required: true, message: '请选择车场', trigger: 'change' }],
        fileName: [
          { required: true, message: '请选择月卡车文件', trigger: 'change' },
          { required: true, message: '请选择月卡车文件', trigger: 'blur' },
        ],
      },
      payParams_: '',
      roomSelectionShowBoxFlag: false,
      reviewRoomSelectionShowBoxFlag: false,
      editRoomSelectionShowBoxFlag: false,
      operateType: 0,
      zhxx: [],
      paySceneList: [],
      targetList: [],
      buildingList: [],
      payTypeList: [],
      payInfo: {},
      payInfo2: {
        showQrCode: false,
        tradeStatus: '',
        countdown: '',
      },
      carMonthCardPayForm: {},
      carMonthPayFormOption: carMonthPayFormOption,
      showMonthCarPayFlag: false,
      statusCountNew: {
        expiredNum: 0, //已过期
        normalNum: 0, //正常
        toAuditNum: 0, //待审核
        toPayNum: 0, //待付款
      },
      dialogDisabled: false,
      reWrite: false,
      exportExcelFlag: false,
      exportExcelOption: exportExcelOption,
      exportExcelForm: {},
      tempStopUnPayDialogFlag: false,
      areaName: '',
      refundCheckexpiredTime: true,
      refundCheckReturnMoney: true,

      iscarMonthRenewDialogFirstOpen: true,
      carMonthRenewShowDialogFlag: false,
      carMonthRenewForm: {},
      carMonthRenewOption: carMonthRenewOption,

      iscarMonthReviewDialogFirstOpen: true,
      carMonthReviewShowDialogFlag: false,
      carMonthReviewForm: {},
      carMonthReviewOption: carMonthReviewOption,

      iscarMonthEditDialogFirstOpen: true,
      carMonthEditShowDialogFlag: false,
      carMonthEditForm: {},
      carMonthEditOption: carMonthEditOption,

      iscarMonthViewDialogFirstOpen: true,
      carMonthViewShowDialogFlag: false,
      carMonthViewForm: {},
      carMonthViewOption: carMonthViewOption,

      iscarMonthPayDialogFirstOpen: true,
      carMonthPayShowDialogFlag: false,
      carMonthPayForm: {},
      carMonthPayOption: carMonthPayOption,

      iscarMonthChangeDialogFirstOpen: true,
      carMonthChangeShowDialogFlag: false,
      carMonthChangeForm: {},
      carMonthChangeOption: carMonthChangeOption,

      iscarMonthRefundDialogFirstOpen: true,
      carMonthRefundShowDialogFlag: false,
      carMonthRefundForm: {},
      carMonthRefundOption: carMonthRefundOption,

      iscarMonthCopyDialogFirstOpen: true,
      carMonthCopyShowDialogFlag: false,
      carMonthCopyForm: {},
      carMonthCopyOption: carMonthCopyOption,
      regionFirstIdTemp: '',
      addFlag: false,

      effectTimeTemp: '',
      expiredTimeTemp: '',

      form: {},
      query: {
        spaceId: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      carNoList: [],
      selectionList: [],
      showImportDialog: false,
      spaceList: [],
      statusList: [],
      carTypeList: [],
      firstDisplayFlag: false,
      tempSpaceId: '',
      option: {
        addBtn: false,
        height: 'auto',
        searchShow: true,
        searchMenuSpan: 12,
        span: 6,
        calcHeight: 120,
        tip: true,
        border: true,
        index: true,
        // viewBtn: true,
        viewBtn: false,
        editBtn: false,
        // delBtn: true,
        delBtn: false,
        selection: true,
        menuWidth: 200,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        selectionClearBtn: true,

        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            formslot: true,
            editDisabled: false,
            clearable: false,
            span: 8,
              searchOrder:7,
            search: true,
            cell: true,
            hide: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },


          {
            label: '车辆身份',
            prop: 'carManageType',
            search: true,
              order:10,
              searchOrder:5,
            type:'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=car_manage_type',
            span: 8,
          },

          {
            label: '区域名称',
            prop: 'regionNames',
            span: 8,
            display: false,

          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            search: true,
              order:9,
              searchOrder:4,
            editDisabled: true,
            formslot: true,
            filterable: false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请选择车牌号',
                trigger: 'change',
              },
              {
                pattern: this.$validation.carPlate,
                message: '车牌号格式错误',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费套餐',
            prop: 'feeRuleName',
          },
          {
            label: '优惠规则',
            showColumn:false,
            prop: 'discountRuleName',
          },
          {
            label: '主/副车',
            prop: 'isMainCar',
            showColumn:false,
          },
          {
            label: '主/副车',
            prop: 'showIsMainCar',
            order:8,
            width: 70,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData: [{
              dictKey:0,
              dictValue:'副车'
            },{
              dictKey:1,
              dictValue:'主车'
            }],
            span: 8,
          },
          {
            label: '车位编号',
            prop: 'parkingSpaceNames',
            span: 8,
              searchOrder:6,
            search: true,
          },
          {
            label: '名下副车/对应主车',
            prop: 'mainOrSecondPlateNumber',
          },
          {
            label: '车辆分类',
            span: 8,
            hide: true,
            showColumn: false,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择车辆分类',
                trigger: 'change',
              },
            ],
            dataType: 'number',
            prop: 'carClass',
          },
          {
            label: '车辆类型',
            span: 8,
            hide: true,
            showColumn: false,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            disable: true,
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请选择车辆类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主姓名',
            span: 8,
            prop: 'personName',
            width: 70,
            search: true,
            maxlength: 10,
              searchOrder:3,
            disabled: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入车主姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主电话',
            prop: 'personPhone',
            search: true,
            width: 100,
            span: 8,
              searchOrder:2,
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入车主电话',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '状态',
            prop: 'carStatus',
             search: true,
            width: 70,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            span: 8,
            editDisplay: false,
            addDisplay: false,
            rules: [
              {
                message: '请输入同步标识  0未同步  1已同步',
                trigger: 'change',
              },
            ],
          },
          {
            label: '剩余天数',
            prop: 'remainDays',
            search: true,
            width: 70,
            type: 'number',
          },
          {
            label: '生效起期',
            prop: 'effectTime',
            type: 'date',
            width: 110,
            format: 'yyyy-MM-dd',
          },
          {
            label: '有效期止',
            prop: 'expiredTime',
            type: 'date',
            width: 110,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入租赁止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.effectTime);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('租赁止期必须大于租赁起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '公司名称/住所',
            prop: 'roomName',
            type: 'input',

            search:true,
            span: 6,
              searchOrder:1,
            searchLabelWidth: 110,
            display: false,
          },
          {
            label: '房间',
            prop: 'areaId',
            type: 'tree',
            hide: true,
            showColumn: false,
            span: 16,
            display: false,
          },
          {
            label: '电子资料',
            prop: 'imgUrl',
            hide: true,
            showColumn: false,
            type: 'upload',
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过500kb',
            span: 24,
            row: true,
          },
          {
            label: '备注',
            prop: 'remark1',
            type: 'textarea',
            hide: true,
            showColumn: false,
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            minRows: 2,
            overHidden: true,
            rules: [
              {
                required: false,
                message: '办公车辆请输入备注说明',
                trigger: 'change',
              },
            ],
          },
          {
            addDisplay: false,
            editDisplay: false,
            label: '操作日志',
            prop: 'info',
            span: 24,
            hide: true,
            showColumn: false,
            formslot: true,
          },
          {
            label: '租赁起期',
            prop: 'dateStartRange',
            span: 24,
            search: false,
            searchRange: true,
            hide: true,
            showColumn: false,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '有效期止',
            prop: 'dateEndRange',
            searchSpan: 6,
            searchslot: true,
             search: true,
            searchRange: true,
            hide: true,
            showColumn: false,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '余额(元)',
            prop: 'balance',
            width: 80,
          },
        ],
      },
      infoOption: {
        header: false,
        addBtn: false,
        menu: false,
        border: true,
        column: [
          {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            dicData: [
              {
                label: '月卡车审核',
                value: 1,
              },
              {
                label: '新增月卡车',
                value: 2,
              },
              {
                label: '修改月卡车',
                value: 6,
              },
              {
                label: '月卡车退费',
                value: 4,
              },
              {
                label: '变更车牌',
                value: 3,
              },
              {
                label: '删除过期车辆',
                value: 7,
              },
              {
                label: '月卡车信息已同步至岗亭',
                value: 8,
              },
              {
                label: '补缴月卡车更新临停记录',
                value: 9,
              },
            ],
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            width: 400,
          },
          {
            label: '操作人',
            width: 100,
            prop: 'remark3',
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },
        ],
      },
      unPayOption: {
        addBtn: false,
        menu: false,
        border: true,
        columnBtn: false,
        refreshBtn: false,
        align: 'center',
        column: [
          {
            label: '停车场',
            prop: 'spaceName',
            width: 110,
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            width: 90,
          },
          {
            label: '欠费（元）',
            prop: 'bankMoney',
          },
          {
            label: '停车时长（时）',
            prop: 'parkTime',
          },
          {
            label: '入场时间',
            prop: 'inTime',
            searchSpan: 6,
            width: 130,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '出场时间',
            prop: 'outTime',
            type: 'datetimerange',
            searchRange: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 130,
          },
          {
            label: '应缴（元）',
            prop: 'payableMoney',
          },
          {
            label: '实收（元）',
            prop: 'chargeMoney',
          },
        ],
      },
      unPayData: [],
      data: [],
      payFormTitle: '',
      payDisabled: true,
      quickRegistrationVisible: false, //月卡车快速登记弹框
      quickRegistrationForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        effectTime: '',
        expiredTime: '',
        cycleNum: '',
        discountId: '',
        shouldAmount: '',
        cutMoney: '',
        payMoney: '',
        remark: '',
      }, //快速登记表单

      //高级修改弹框
      viewNormalVisible: false,
      //高级修改表单
      viewNormalForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        effectTime: '',
        expiredTime: '',
        discountId: '',
        lotNo: '',
        areaName: '',
        status: '',
        carStatus: '',
      },
      //退款弹框
      refundVisible: false,
      //退款表单
      refundForm: {
        id: '',
        spaceName: '',
        plateNumber: '',
        carManageType: '',
        personName: '',
        personPhone: '',
        effectTime: '',
        expiredTime: '',
        newEndTime: '',
        refundAmount: '',
        description: '',
      },
      //审核弹框
      approveVisible: false,
      //审核表单
      approveForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        effectTime: '',
        expiredTime: '',
        discountId: '',
        lotNo: '',
        areaName: '',
        carStatus: '',
        description: '',
      },
      //高级修改弹框
      editNormalVisible: false,
      //高级修改表单
      editNormalForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        effectTime: '',
        expiredTime: '',
        discountId: '',
        lotNo: '',
        areaName: '',
        status: '',
        carStatus: '',
      },
      //高级修改弹框
      editPlusVisible: false,
      //高级修改表单
      editPlusForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        effectTime: '',
        expiredTime: '',
        discountId: '',
        lotNo: '',
        areaName: '',
        status: '',
        carStatus: '',
      },
    };
  },

  watch: {
    'query.spaceId'() {
      this.parkingLotId = this.query.spaceId;
    },
    'form.shouldAmount'() {
      const column = this.findObject(this.option.column, 'shouldAmount');
      if (this.form.carStatus == 3 || this.form.carStatus == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    'form.payMoney'() {
      const column = this.findObject(this.option.column, 'payMoney');
      if (this.form.carStatus == 3 || this.form.carStatus == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    //用于监听复制车场关联区域
    'carMonthCopyForm.spaceId'() {
      nodeTreeByParentId(this.carMonthCopyForm.spaceId).then((res) => {
        const column = this.findObject(this.carMonthCopyOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
    },
  },
  computed: {
    ...mapGetters(['permission']),
    ...mapGetters(['tagList']),
    ...mapGetters(['userInfo']),
    permissionList() {
      return {
        //车牌变更
        plateBtn: this.vaildData(this.permission.carmonth_plate_change_v3, false),
        //修改
        editBtn: this.vaildData(this.permission.carmonth_manage_edit_v3, false),
        //高级修改普通版
        editBtnNormal: this.vaildData(this.permission.carmonth_manage_edit_plus_normal_v3, false),
        //审核
        auditBtn: this.vaildData(this.permission.carmonth_manage_audit_v3, false),
        //付款
        payBtn: this.vaildData(this.permission.carmonth_manage_pay_v3, false),
        //续约
        contractBtn: this.vaildData(this.permission.carmonth_manage_contract_v3, false),
        //删除
        delBtn: this.vaildData(this.permission.carmonth_manage_del_v3, false),
        //下载模板
        downloadBtn: this.vaildData(this.permission.carmonth_manage_download_v3, false),
        //导入月卡车
        uploadBtn: this.vaildData(this.permission.carmonth_manage_upload_v3, false),
        quickBtn: this.vaildData(this.permission.quickBtn_v3, false),
        editPlusBtn: this.vaildData(this.permission.carmonth_manage_edit_plus_v3, false),
        invoiceBtn: this.vaildData(this.permission.carmonth_manage_invoiceBtn_v3, false),
        refundBtn: this.vaildData(this.permission.carmonth_refund_v3, false),
        exportCarBtn: this.vaildData(this.permission.car_manage_export, false),
        syncBtn: false,
        syncPlusBtn: false,
      };
    },
    infoData() {
      return this.carMonthViewForm.info;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    permissions() {
      return {
        propertyAmountCheck: this.vaildData(
          this.permission.propertyCharge_propertyAmountCheck,
          false
        ),
        otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
        proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
        byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
        byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
        byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
      };
    },

    payParams() {
      let params = this._.merge(
        {
          roomId: this.carMonthEditForm.communityId || '',
          roomName: this.carMonthCardPayForm.communityName || '',
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.carMonthCardPayForm.roomId ? this.zhxx.householder : '',
        },
        {
          payInfo: {
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: 0,
            carTotalAmount: this.totalShouldAmountCP,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalShouldAmountCP,
            totalAccountpayAmount: 0,
            totalPayAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify([
              {
                feeType: 'carPay',
                feeName: this.carMonthCardPayForm.ruleName,
                feePeriod:
                  this.carMonthCardPayForm.effectTime +
                  ' - ' +
                  this.carMonthCardPayForm.expiredTime,
                calAmount: this.totalShouldAmountCP,
                derateAmount: 0 + '',
                couponAmount: 0 + '',
                shouldAmount: this.totalShouldAmountCP + '',
              },
            ]),
          },
        }
      );
      params.carPay = this.carMonthCardPayForm;
      params.roomId = this.carMonthCardPayForm.communityId;
      params.roomName = this.carMonthCardPayForm.communityName;
      params.carPay.communityId = this.carMonthCardPayForm.spaceId;
      params.carPay.shouldAmount = this.totalShouldAmountCP;
      params.carPay.calAmount = this.totalShouldAmountCP;
      // params.carPay.payAmount = this.totalShouldAmountCP;
      params.carPay.backAmount = 0;

      return params;
    },

    billTotalAmountCP() {
      return Number(this.carMonthCardPayForm.shouldAmount);
    },
    totalShouldAmountCP() {
      return this.billTotalAmountCP;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 510) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 510;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  created() {
    this.option.height = this.bodyHeight - 510;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[0].dicData = data.data;
        this.option.column[0].searchValue = this.spaceList[0].id;
        this.query.spaceId = this.spaceList[0].id;
        this.searchForm.spaceId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    //打开退款
    openCarManageRefundDialog() {
      if (this.selectionList.length==0||this.selectionList.length>1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      if (this.selectionList[0].carManageType != 1
        || this.selectionList[0].isMainCar != 1
        || this.selectionList[0].carStatus != 3) {
        this.$message.warning('请选择状态为【正常】的月卡主车进行退费操作');
        return;
      }
      getManageDetail({id:this.selectionList[0].id}).then(res=>{
        this.refundForm = res.data
        this.refundVisible = true;
      });
    },
    exportCarManageExcel() {
      this.$confirm("是否导出车辆管理数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //导出数据
        let spaceId = this.query.spaceId;
        if (this.vdui.isEmpty(this.query.spaceId)) {
          spaceId = this.tempSpaceId;
        }
        let parkingSpaceNames = this.query.parkingSpaceNames;
        if (this.vdui.isEmpty(this.query.parkingSpaceNames)) {
          parkingSpaceNames = '';
        }
        let carManageType = this.query.carManageType;
        if (this.vdui.isEmpty(this.query.carManageType)) {
          carManageType = '';
        }
        let plateNumber = this.query.plateNumber;
        if (this.vdui.isEmpty(this.query.plateNumber)) {
          plateNumber = '';
        }
        let personName = this.query.personName;
        if (this.vdui.isEmpty(this.query.personName)) {
          personName = '';
        }
        let personPhone = this.query.personPhone;
        if (this.vdui.isEmpty(this.query.personPhone)) {
          personPhone = '';
        }
        let roomName = this.query.roomName;
        if (this.vdui.isEmpty(this.query.roomName)) {
          roomName = '';
        }
        let carStatus = this.query.carStatus;
        if (this.vdui.isEmpty(this.query.carStatus)) {
          carStatus = '';
        }
        let remainDays = this.query.remainDays;
        if (this.vdui.isEmpty(this.query.remainDays)) {
          remainDays = '';
        }
        let expiredTimeStart = '';
        let expiredTimeEnd = '';
        if(this.query.expiredTimeStart){
          expiredTimeStart = this.query.expiredTimeStart;
        }
        if(this.query.expiredTimeEnd){
          expiredTimeEnd = this.query.expiredTimeEnd;
        }
        window.open(
          `/api/v4ward/car/manage/exportCar?${
            this.website.tokenHeader
          }=${getToken()}&spaceId=${spaceId}&parkingSpaceNames=${parkingSpaceNames}&carManageType=${carManageType}&plateNumber=${plateNumber}&personName=${personName}&personPhone=${personPhone}&roomName=${roomName}&carStatus=${carStatus}&remainDays=${remainDays}&expiredTimeStart=${expiredTimeStart}&expiredTimeEnd=${expiredTimeEnd}`
        );

      });
    },
    importSuccess(){
      this.isImportDialogShow =false
      this.onLoad()
    },
    exportCar(val){
      this.carManageType = val
     if(val==1){
      this.importTitle = '月卡车导入';
     }else if(val==2){
      this.importTitle ="固定车导入"
     }else{
      this.importTitle ="储值车导入"
     }
      this.isImportDialogShow =true
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },
    cycleNumChange(val){
            let self = this;
            this.carMonthCardPayForm.discountRuleId = '';
      calculateMonthCarFeeInFo(
          Object.assign({
            spaceId: this.carMonthCardPayForm.spaceId,
            effectTime: this.carMonthCardPayForm.effectTime,
            cycleNum: val,
            feeRuleId: this.carMonthCardPayForm.feeRuleId,
            discountRuleId: this.carMonthCardPayForm.discountRuleId
          })
        ).then(({ data }) => {
          if (data) {
            this.carMonthCardPayForm.expiredTime = data.feeEndTime;
            this.carMonthCardPayForm.discountAmount = data.discountAmount;
            this.carMonthCardPayForm.payAmount = data.payAmount;
            this.carMonthCardPayForm.shouldAmount = data.shouldAmount;
            this.carMonthCardPayForm = this._.cloneDeep(self.carMonthCardPayForm);
            // this.
            getCarRuleDiscountListNew({

            spaceId: self.carMonthCardPayForm.spaceId,
            payPeriods: self.carMonthCardPayForm.cycleNum,

        carFeeRuleId: self.carMonthCardPayForm.feeRuleId,
            }).then(({ data }) => {
            self.discountRuleList = data;
            })
          }
        });
    },
    discountRuleIdChange(val){

            let self = this;
      calculateMonthCarFeeInFo(
          Object.assign({
            spaceId: this.carMonthCardPayForm.spaceId,
            effectTime: this.carMonthCardPayForm.effectTime,
            cycleNum: this.carMonthCardPayForm.cycleNum,
            feeRuleId: this.carMonthCardPayForm.feeRuleId,
            discountRuleId: val
          })
        ).then(({ data }) => {
          if (data) {
            this.carMonthCardPayForm.expiredTime = data.feeEndTime;
            this.carMonthCardPayForm.discountAmount = data.discountAmount;
            this.carMonthCardPayForm.payAmount = data.payAmount;
            this.carMonthCardPayForm.shouldAmount = data.shouldAmount;
            this.carMonthCardPayForm = this._.cloneDeep(self.carMonthCardPayForm);
          }
        });
    },
    //获取续租时长
    getCycleNumList() {
      getDictionary('park_fee_cycle').then((res) => {
        this.cycleNumList = res.data;
      });
    },
    payAmountInputChange(){
      this.carMonthCardPayForm.discountAmount = 0.0;
      console.log('>>>>>>>>>>>>>', this.carMonthCardPayForm.payAmount);
      if (this.carMonthCardPayForm.rechargeAmount <= 0) {
        console.log('>>>>>>>>>>>>>', this.carMonthCardPayForm.payAmount);
      } else {
      }
    },
    secondCarMainChange(){
      if(this.selectionList.length==0||this.selectionList.length>1){
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      this.mainRow = this.selectionList[0];


      if(this.mainRow.isMainCar==1){
        this.mainFlag = true;
      mainCarChangeOrRemoveCheck({id:this.mainRow.id}).then(res=>{
          console.log(res);
        this.showMainCarChangeFlag = true;
          this.subCarList = res.data;
          this.tempSubCarId = this.subCarList[0].id;
      })
      }else{
        this.mainFlag = false;
      secondCarChangeCheck({id:this.mainRow.id}).then(res=>{
        this.showMainCarChangeFlag = true;
          console.log(res);
          this.subCarList = [res.data];
          this.tempSubCarId = this.subCarList[0].id;
      })
      }
    },
    cancelMainSubChange(){
      this.showMainCarChangeFlag = false;
    },
    // saveSubcar mainSecondChange
    saveMainSubChange(){
      mainSecondChange({currentId:this.mainRow.id,targetId:this.tempSubCarId}).then(res=>{

        this.showMainCarChangeFlag = false;

            this.onLoad();
        if(this.deleteBtnFlag){
          this.deleteBtnFlag = false;
          removeMainCar({id:this.mainRow.id}).then((res)=>{
            this.$message.success('操作成功！');
            this.onLoad();
          })
        }else{

            this.$message.success('操作成功！');
            this.onLoad();
        }
      })
    },
    handleDelete() {
      if (this.selectionList.length !== 1) {
        this.$message.warning('一次只能注销一条数据');
        return;
      }
      console.log('this.selectionList[0]', this.selectionList[0])
      if(this.selectionList[0].carManageType == 1){
        if(this.selectionList[0].carStatus==3 || this.selectionList[0].carStatus==4){
          this.$message.warning('当前车辆状态为正常，请勿删除');
          return;
        }
      }
      if(this.selectionList[0].isMainCar==0){

          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            removeMainCar({id:this.ids}).then((res)=>{
              this.$message.success('操作成功！');

              this.onLoad();
            })
          });
      }else{
        this.mainRow = this.selectionList[0];
          mainCarChangeOrRemoveCheck({id:this.ids}).then(res=>{
            this.subCarList = res.data;
            if(this.subCarList.length>0){
              this.showMainCarChangeFlag = true;
              this.deleteBtnFlag = true;
              if(this.subCarList.length==1){
                this.tempSubCarId = this.subCarList[0].id;
              }else{
              }
            }else{
              this.$confirm('确定将选择数据删除?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                removeMainCar({id:this.ids}).then((res)=>{
                  this.$message.success('操作成功！');

                  this.onLoad();
                })
              });
            }
          })
      }
    },
    handleDeleteCarMonth(row){
      this.deleteBtnFlag = false;
        this.mainRow = row;
      if(row.isMainCar==1){
        mainCarChangeOrRemoveCheck({id:row.id}).then(res=>{
          console.log(res);
          this.subCarList = res.data;
          if(this.subCarList.length>0){
            this.showMainCarChangeFlag = true;
            this.deleteBtnFlag = true;
            if(this.subCarList.length==1){
              this.tempSubCarId = this.subCarList[0].id;
            }else{
              //todo;
            }
          }else{
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeMainCar({ id: row.id });
        })
        .then(() => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
        });

          }
        })
      }else{

      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeMainCar({ id: row.id });
        })
        .then(() => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
        });
      }
    },
    // 打开开票信息编辑弹窗
    openMakeOutAnInvoiceDialog(row) {
      this.$refs.makeOutAnInvoice.openDialog(row);
    },
    quickAddSuccess() {
      this.quickRegistrationVisible = false;
      this.onLoad();
    },
    quickAddCancle() {
      console.log('关闭');
      this.quickRegistrationVisible = false;
    },
    //打开快速登记
    openCarMonthQuickRegistrationDialog() {
      this.quickRegistrationForm.spaceId = this.searchForm.spaceId;
      this.quickRegistrationForm.plateNumber = '';
      this.quickRegistrationForm.regions = '';
      this.quickRegistrationForm.personName = '';
      this.quickRegistrationForm.personPhone = '';
      this.quickRegistrationForm.isMainCar = '';
      this.quickRegistrationForm.bigOrSmallCar = '';
      this.quickRegistrationForm.feeRuleId = '';
      this.quickRegistrationForm.carManageType = '';
      this.quickRegistrationForm.effectTime = '';
      this.quickRegistrationForm.expiredTime = '';
      this.quickRegistrationForm.cycleNum = '';
      this.quickRegistrationForm.discountRuleId = '';
      this.quickRegistrationForm.shouldAmount = '';
      this.quickRegistrationForm.discountAmount = '';
      this.quickRegistrationForm.payAmount = '';
      this.quickRegistrationForm.description = '';
      this.quickRegistrationForm.buildingId = '';
      this.quickRegistrationForm.roomId = '';
      this.quickRegistrationForm.roomName = '';
      this.quickRegistrationForm = this._.cloneDeep(this.quickRegistrationForm);
      this.quickRegistrationVisible = true;
    },
    //打开审核页面
    openCarMonthApproveDialog(row) {
      let str = JSON.stringify(row);
      this.approveForm = JSON.parse(str);
      console.log(row);
      this.approveVisible = true;
    },
    approveSuccess() {
      this.approveVisible = false;
      this.onLoad();
    },
    approveCancel() {
      this.approveVisible = false;
    },
    refundSuccess() {
      this.refundVisible = false;
      this.onLoad();
    },
    refundCancel() {
      this.refundVisible = false;
    },
    viewNormalSuccess() {
      this.viewNormalVisible = false;
      this.onLoad();
    },
    viewNormalCancel() {
      console.log('取消时关闭');
      this.viewNormalVisible = false;
    },
    //打开高级修改
    openCarMonthViewNormalDialog(row) {
      getManageDetail({id:row.id}).then(res=>{
        row.carManageLogList = res.data.carManageLogList;
        let str = JSON.stringify(row);
        this.viewNormalForm = JSON.parse(str);
        this.viewNormalVisible = true;
      });
    },

    editNormalSuccess() {
      this.editNormalVisible = false;
      this.onLoad();
    },
    editNormalCancel() {
      console.log('取消时关闭');
      this.editNormalVisible = false;
    },
    //打开高级修改
    openCarMonthEditNormalDialog(row) {
      let str = JSON.stringify(row);
      this.editNormalForm = JSON.parse(str);
      this.editNormalVisible = true;
    },

    editPlusSuccess() {
      this.editPlusVisible = false;
      this.editPlusNormalVisible = false
      this.onLoad();
    },
    editPlusCancel() {
      console.log('取消时关闭');
      this.editPlusNormalVisible = false
      this.editPlusVisible = false;
    },
    //打开高级修改
    openCarMonthEditPlusDialog() {
      if (this.selectionList.length==0||this.selectionList.length>1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      if (
        this.selectionList[0].carStatus != 3 &&
        this.selectionList[0].carStatus != 5 &&
        this.selectionList[0].carStatus != 4
      ) {
        this.$message.warning('请选择状态为[正常]或[已过期]的数据进行操作');
        return;
      }
      let str = JSON.stringify(this.selectionList[0]);
      this.editPlusForm = JSON.parse(str);
      console.log(this.editPlusForm );
      this.editPlusVisible = true;
    },
    openCarMonthEditPlusNormalDialog() {
      if (this.selectionList.length==0||this.selectionList.length>1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      if (
        this.selectionList[0].carStatus != 3 &&
        this.selectionList[0].carStatus != 5 &&
        this.selectionList[0].carStatus != 4
      ) {
        this.$message.warning('请选择状态为[正常]或[已过期]的数据进行操作');
        return;
      }
      let str = JSON.stringify(this.selectionList[0]);
      this.editPlusForm = JSON.parse(str);
      console.log(this.editPlusForm );
      this.editPlusNormalVisible  = true;
    },
    //修改时初始化优惠规则
    initEditDiscountRule() {
      if (!this.editWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthEditForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthEditForm.ruleId.id) {
        chargeRuleId = this.carMonthEditForm.ruleId.id;
      }
      carMonthRuleV2({
        spaceId: this.carMonthEditForm.spaceId,
        payPeriods: this.carMonthEditForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthEditForm.discountId = data[0].id;
        } else {
          this.carMonthEditForm.discountId = '';
        }
      });
    },
    //续约时初始化优惠规则
    initPayDiscountRule() {
      if (!this.payWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthCardPayForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthCardPayForm.ruleId) {
        if (this.carMonthCardPayForm.ruleId.id) {
          chargeRuleId = this.carMonthCardPayForm.ruleId.id;
        }
      }
      carMonthRuleV2({
        spaceId: this.carMonthCardPayForm.spaceId,
        payPeriods: this.carMonthCardPayForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthCardPayForm.discountId = data[0].id;
        } else {
          this.carMonthCardPayForm.discountId = '';
        }
      });
    },
    //审核时初始化优惠规则
    initReviewDiscountRule() {
      if (!this.reviewWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthReviewForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthReviewForm.ruleId.id) {
        chargeRuleId = this.carMonthReviewForm.ruleId.id;
      }
      carMonthRuleV2({
        spaceId: this.carMonthReviewForm.spaceId,
        payPeriods: this.carMonthReviewForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthReviewForm.discountId = data[0].id;
        } else {
          this.carMonthReviewForm.discountId = '';
        }
      });
    },
    //续约时初始化租赁结束时间
    initPayEndTime() {
      if (!this.payWatchOpen) {
        return;
      }
      let effectTime = dayjs(this.carMonthPayForm.startTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !effectTime ||
        effectTime == 'Invalid Date' ||
        JSON.stringify(effectTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthPayForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthPayForm.cycleNum,
          startTime: effectTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthPayForm.expiredTime = data.endTime;
        }
      });
    },
    //审核时初始化租赁结束时间
    initReviewEndTime() {
      if (!this.reviewWatchOpen) {
        return;
      }
      let effectTime = dayjs(this.carMonthReviewForm.effectTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !effectTime ||
        effectTime == 'Invalid Date' ||
        JSON.stringify(effectTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthReviewForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthReviewForm.cycleNum,
          startTime: effectTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthReviewForm.expiredTime = data.endTime;
        }
      });
    },
    //修改时初始化租赁结束时间
    initEditEndTime() {
      if (!this.editWatchOpen) {
        return;
      }
      let effectTime = dayjs(this.carMonthEditForm.effectTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !effectTime ||
        effectTime == 'Invalid Date' ||
        JSON.stringify(effectTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthEditForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthEditForm.cycleNum,
          startTime: effectTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthEditForm.expiredTime = data.endTime;
        }
      });
    },
    //初始化收费规则
    initEditChargeRule() {
      if (!this.editWatchOpen) {
        return;
      }
      if (!this.carMonthEditForm.spaceId) {
        return;
      }
      const feeRuleIdColumn = this.findObject(this.carMonthEditOption.column, 'ruleId');
      monthChargeRuleListV2(
        Object.assign({
          spaceId: this.carMonthEditForm.spaceId,
          carType: this.carMonthEditForm.carType,
          carCategory: this.carMonthEditForm.carCategory,
        })
      ).then(({ data }) => {
        feeRuleIdColumn.dicData = data;
        if (data.length == 0) {
          feeRuleIdColumn.dicData = ['1111'];
        }
        if (data[0]) {
          this.carMonthEditForm.ruleId = this.carMonthEditForm.ruleId;
        } else {
          this.carMonthEditForm.ruleId = '';
        }
      });
    },
    openMonthCarEmportForm() {
      this.importMonthCarForm.parkId = this.query.spaceId;
      this.showImportDialog = true;
    },
    exportMonthCar(f) {
      const formData = new FormData();
      formData.append('parkId', this.importMonthCarForm.parkId);
      formData.append('file', f.file);
      this.importButtonDisabled = true;
      exportMonthCarList(formData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success('上传成功!');
            this.importMonthCarForm = {};
            this.showImportDialog = false;
            this.importButtonDisabled = false;
            this.selectFileDisabled = false;
            this.onLoad();
          }
        })
        .catch(() => {
          var parkId = this.importMonthCarForm.parkId;
          this.importMonthCarForm = {
            parkId: parkId,
            fileName: '',
          };
          this.importButtonDisabled = false;
          f.onError();
        });
    },
    uploadMonthCar() {
      this.$refs['importMonthCarForm'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        }
      });
    },
    cancelUploadMonthCar() {
      var parkId = this.importMonthCarForm.parkId;
      this.importMonthCarForm = {
        parkId: parkId,
        fileName: '',
      };
      this.showImportDialog = false;
      this.selectFileDisabled = false;
      this.importButtonDisabled = false;
    },
    loadJsonFromFile(file, fileList) {
      if (fileList.length > 0) {
        this.importMonthCarForm.fileName = file.name;
      }
      this.$refs['importMonthCarForm'].validate();
      this.selectFileDisabled = fileList.length > 0;
    },
    downloadTemplate() {
      window.open(
        `/api/v4ward/car/CarMonth/downTemplate/v2?Blade-Auth=${getToken()}&parkId=` +
          this.query.spaceId
      );
    },
    isAdmin() {
      var account = this.userInfo.account;
      if (this.vdui.isEmpty(account)) {
        return false;
      }
      return account.includes('admin');
    },
    //打印预览
    printprev() {
      this.$confirm('收费成功，是否需要打印收据？', '提示', {
        confirmButtonText: '打印',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (
            this.payInfo.payBillNo != ''
          ) {
            this.showMonthCarPayFlag = false;
            this.$refs.carMonthCardPayForm.resetForm();
            this.onLoad();

            this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
          } else {
            this.$message.warning('请先完成收款');
          }
        })
        .catch(() => {
          this.showMonthCarPayFlag = false;
          this.$refs.carMonthCardPayForm.resetForm();
          this.onLoad();
        });
    },
    //关闭二维码
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
    },
    confirmRoomSelection() {
      this.roomSelectionShowBoxFlag = false;
    },
    reviewConfirmRoomSelection() {
      this.reviewRoomSelectionShowBoxFlag = false;
    },
    editConfirmRoomSelection() {
      this.editRoomSelectionShowBoxFlag = false;
    },
    roomSelectionOpen() {
      this.roomSelectionShowBoxFlag = true;
    },
    reviewRoomSelectionOpen() {
      this.reviewRoomSelectionShowBoxFlag = true;
    },
    editRoomSelectionOpen() {
      this.editRoomSelectionShowBoxFlag = true;
    },
    //初始化化应收金额
    initShoudMoneyEdit() {
      if (this.vdui.isNotEmpty(this.carMonthEditForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthEditForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          discountId: this.carMonthEditForm.discountId,
          ruleId: this.carMonthEditForm.ruleId,
          cycleNum: this.carMonthEditForm.cycleNum,
          startTime: this.carMonthEditForm.effectTime,
          backAmount: this.carMonthEditForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthEditForm.shouldAmount = data.shouldAmount;
          this.carMonthEditForm.payMoney = data.payAmount;
          this.carMonthEditForm.expiredTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.carMonthEditForm.shouldAmount) {
          this.carMonthEditForm.shouldAmount = 0;
        }
        if (!this.carMonthEditForm.payMoney) {
          this.carMonthEditForm.payMoney = 0;
        }
        return;
      }
    },
    //初始化化应收金额
    initshouldAmountReview() {
      if (!this.reviewWatchOpen) {
        return;
      }
      if (this.vdui.isNotEmpty(this.carMonthReviewForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthReviewForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        let discountRuleId = this.carMonthReviewForm.discountId;
        if (this.carMonthReviewForm.discountId) {
          if (this.carMonthReviewForm.discountId.id) {
            discountRuleId = this.carMonthReviewForm.discountId.id;
          }
        }
        let effectTime = dayjs(this.carMonthReviewForm.effectTime).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        if (effectTime == 'Invalid Date' || JSON.stringify(effectTime) === '{}') {
          console.log('时间为空>>>>');
          return;
        }
        loadCarPayAmount({
          discountId: discountRuleId,
          ruleId: this.carMonthReviewForm.ruleId,
          cycleNum: this.carMonthReviewForm.cycleNum,
          startTime: effectTime,
          backAmount: this.carMonthReviewForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthReviewForm.shouldAmount = data.shouldAmount;
          this.carMonthReviewForm.expiredTime = data.endTime;
        });
      } else {
        if (!this.carMonthReviewForm.shouldAmount) {
          this.carMonthReviewForm.shouldAmount = 0;
        }
        if (!this.carMonthReviewForm.payMoney) {
          this.carMonthReviewForm.payMoney = 0;
        }
        return;
      }
    },
    cancelPay() {
      this.showMonthCarPayFlag = false;
    },
    confirmPayAction() {
      let self = this;
      var date = new Date();

      // if(new Date(self.carMonthCardPayForm.effectTime) > date){
      //     this.$confirm('续费后仍然为<span style="color: red;">未生效</span>状态，请确认续约时间范围！', '提示', {
      //       confirmButtonText: '确认收费',
      //       cancelButtonText: '取消',
      //       dangerouslyUseHTMLString:true,
      //       type: 'warning',
      //     })
      //     .then(() => {
      //       this.$refs.carMonthCardPayForm.submit();
      //     })
      //     .catch(() => {
      //      // 用户点击了取消按钮
      //     this.$message({
      //       type: 'info',
      //       message: '操作已取消'
      //     });
      //   });
      //   return;
      // }


      if(new Date(self.carMonthCardPayForm.expiredTime) <= date){
          this.$confirm('续费后仍然为<span style="color: red;">已过期</span>状态，请确认续约时间范围！', '提示', {
            confirmButtonText: '确认收费',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString:true,
            type: 'warning',
          })
          .then(() => {
            this.$refs.carMonthCardPayForm.submit();
          })
          .catch(() => {
           // 用户点击了取消按钮
          this.$message({
            type: 'info',
            message: '操作已取消'
          });
        });
        return;
      }

      var payCheckParams = {
        spaceId:self.carMonthCardPayForm.spaceId,
        plateNumber:self.carMonthCardPayForm.plateNumber,
        effectTime: (self.carMonthCardPayForm.carManageType==4||self.carMonthCardPayForm.carManageType==3)?'':self.carMonthCardPayForm.effectTime,
        expiredTime: (self.carMonthCardPayForm.carManageType==4||self.carMonthCardPayForm.carManageType==3)?'':self.dayjs(self.carMonthCardPayForm.expiredTime).format('YYYY-MM-DD')+' 23:59:59',
      };


      carManageCheckPay(payCheckParams, { showLoading: { text: '正在校验车辆信息' } }).then((res) => {
            if(res.data){
                this.$confirm('近期<span style="color: red;">有支付成功</span>订单，请确认开始时间！', '提示', {
                confirmButtonText: '确认收费',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString:true,
                type: 'warning',
                  })
                  .then(() => {
                    this.$refs.carMonthCardPayForm.submit();
                  })
                  .catch(() => {
                  // 用户点击了取消按钮
                  this.$message({
                    type: 'info',
                    message: '操作已取消'
                  });
                });
            }else{
                this.$refs.carMonthCardPayForm.submit();
            }
            
      });
      
    },
    getPayParamsData() {
      let self = this;
      let discountId = self.carMonthCardPayForm.discountId;
      if (discountId) {
        if (self.carMonthCardPayForm.discountId.id) {
          discountId = self.carMonthCardPayForm.discountId.id;
        }
      }
      console.log("self.carMonthCardPayForm.payAmount=================>",self.carMonthCardPayForm.payAmount);
      this.payParams_ = {
        carManageType: self.carMonthCardPayForm.carManageType,
        spaceId:self.carMonthCardPayForm.spaceId,
        id:self.carMonthCardPayForm.id,
        plateNumber:self.carMonthCardPayForm.plateNumber,
        personName: self.carMonthCardPayForm.personName,
        personPhone: self.carMonthCardPayForm.personPhone,
        feeRuleId: self.carMonthCardPayForm.feeRuleId,
        areaId: self.carMonthCardPayForm.areaId,
        areaName: self.carMonthCardPayForm.areaName,
        effectTime: (self.carMonthCardPayForm.carManageType==4||self.carMonthCardPayForm.carManageType==3)?'':self.carMonthCardPayForm.effectTime,
        expiredTime: (self.carMonthCardPayForm.carManageType==4||self.carMonthCardPayForm.carManageType==3)?'':self.dayjs(self.carMonthCardPayForm.expiredTime).format('YYYY-MM-DD')+' 23:59:59',
        cycleNum: (self.carMonthCardPayForm.carManageType==4||self.carMonthCardPayForm.carManageType==3)?'':self.carMonthCardPayForm.cycleNum,
        shouldAmount: self.carMonthCardPayForm.shouldAmount.toFixed(2)+'',
        payAmount: (self.carMonthCardPayForm.payAmount+'').indexOf('.')>-1?(self.carMonthCardPayForm.payAmount+""):(self.carMonthCardPayForm.payAmount.toFixed(2)+''),
        discountAmount: self.carMonthCardPayForm.discountAmount,
        payType: self.carMonthCardPayForm.payType,
        payScene: self.carMonthCardPayForm.payScene,
        operatorType: self.carMonthCardPayForm.operatorType,
        payCost: 1,
        authCode: self.carMonthCardPayForm.authCode,
        discountRuleId: self.carMonthCardPayForm.discountRuleId,
      };
    },
    //生成二维码
    genearateQrCode(form, loading) {
      if (loading) {
        loading();
      }
      let self = this;
      this.$refs.carMonthCardPayForm.validate((valid) => {
        if (valid) {
          if (!this.paySubtnFlag) {
            return;
          }
          this.paySubtnFlag = false;
          self.payParams.payInfo.payType = self.carMonthCardPayForm.payType;
          self.payParams.payInfo.authCode = self.carMonthCardPayForm.authCode;
          self.getPayParamsData();
          if (parseInt(this.carMonthCardPayForm.payScene) == 5) {
            // 二维码
            this.qrCodePay();
          } else if (parseInt(this.carMonthCardPayForm.payScene) == 6) {
            // 扫码枪
            this.authCodePay();
          } else {
            // 现金
            this.normalPay();
          }
        }
      });
    },
    // 生成收款二维码
    qrCodePay() {
      carManagePay(this.payParams_, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          this.paySubtnFlag = true;
          this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.orderNo;
          this.$nextTick(() => {
            new QRCode('qrcodeCar', {
              width: 250,
              height: 250,
              text: data.qrCodeUrl,
            });
          });
          this.payInfo2.showQrCode = true;
          this.payInfo2.countdown = 120;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，二维码弹窗关闭');
              this.resetAllData();
            }
            if (this.payInfo2.countdown % 5 === 0) {
              carManagePayQuery({ orderNo: this.payInfo.payBillNo }).then(({ data }) => {
                this.payInfo2.payStatus = data.payStatus;
                if (parseInt(data.payStatus) == 1) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  this.printprev();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      });
    },
    authCodePay() {
      carManagePay(this.payParams_, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          this.paySubtnFlag = true;
          this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.orderNo;
          this.isSuccess = true;
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
          if (data.orderNo) {
            this.openMaskAndPollingPayStatus();
          } else {
            // 可以打印
            this.printprev();
            this.payInfo2.payStatus = 2;
          }
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      })
    },

    normalPay() {
      this.submitAllBill();
    },
    //保存账单
    submitAllBill() {
      carManagePay(this.payParams_, { showLoading: { text: '处理中' } }).then(
        ({ data, msg }) => {
          this.paySubtnFlag = true;
          this.payInfo.payBillNo = data.orderNo;
          this.isSuccess = data.isSuccess;
          this.$message.success(msg);
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          // 可以打印
          this.printprev();
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      })
    },
    resetAllData() {
      location.reload();
    },
    // 扫码枪轮询
    openMaskAndPollingPayStatus() {
      this.payInfo2.countdown = 120;
      this.payInfo2.timer = setInterval(() => {
        this.payInfo2.countdown--;
        if (this.payInfo2.countdown <= 0) {
          this.$message.error('支付失败');
          this.payInfo2.showQrCode = false;
          clearInterval(this.payInfo2.timer);
          this.payInfo2.countdown = 120;
          window.location.reload();
        } else {
          if (this.payInfo2.countdown % 10 == 0 || this.payInfo2.countdown == 119) {
            carManagePayQuery({ orderNo: this.payInfo.payBillNo }).then(({ data }) => {
              if (parseInt(data.payStatus) == 1) {
                this.payInfo2.payStatus = data.payStatus;
                this.$message.success('支付成功');
                // 可以打印
                this.printprev();
                this.payInfo2.showQrCode = false;
                clearInterval(this.payInfo2.timer);
                this.payInfo2.countdown = 120;
              }
            });
          }
        }
      }, 1000);
    },

    //选中
    confirmBillPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.payBillList)) {
        this.$message.warning('请选择账单');
        return;
      }
      let isLockedObject = this.isPayBillLock(this.payBillList);
      let self = this;
      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.payBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      this._.forEach(self.payBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'temporaryPay',
          feeName: item.billFeeItemName,
          feePeriod: item.billStartDate + ' - ' + item.billEndDate,
          calAmount: item.calAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
    },
    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      return { isLock, index_: index_ };
    },
    payTypeChange(val) {
      if (val) {
        console.log("payTypeChange============>",this.$refs.carMonthCardPayForm.columnOption[0]);
        this.carMonthCardPayForm.payScene = '';
        let len = this.$refs.carMonthCardPayForm.columnOption[0].column.length;
        if(parseInt(val)==1 || parseInt(val)==8 || parseInt(val)==11){
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-5].display=false;
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-4].display=false;
        }else{
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-5].display=true;
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-4].display=true;
        }
        getPaySceneList({ payType: val }).then((res) => {
          this.paySceneList = res.data;
        });
      }
    },
    buildingIdChange(val) {
      if (!val) {
        val = '';
      }
      loadRoomList({ propertyId: val }).then(({ data }) => {
        this.targetList = data;
        this.carMonthCardPayForm.roomId = '';
      });
    },

    targetIdChange(val) {
      loadZhxx({ roomId: val }).then(({ data }) => {
        this.zhxx = data[0];
        this.carMonthCardPayForm.areaName = data[0].roomName;
        this.carMonthCardPayForm.areaId = data[0].roomId;
      });
    },
    handlePayCarMonth(row, operateType,manageType) {
      this.operateType = operateType;
      let column = this.findObject(this.carMonthPayFormOption.column, 'cycleNum');
      let feeRuleIdColumn = this.findObject(this.carMonthPayFormOption.column, 'feeRuleId');
      let feeRuleNameColumn = this.findObject(this.carMonthPayFormOption.column, 'feeRuleName');
      let discountRuleIdColumn = this.findObject(this.carMonthPayFormOption.column, 'discountRuleId');
      let discountRuleNameColumn = this.findObject(this.carMonthPayFormOption.column, 'discountRuleName');
      this.findObject(this.carMonthPayFormOption.column, 'authCode').display = false;
      this.findObject(this.carMonthPayFormOption.column, 'payScene').display = false;
      if (operateType == 1) {
        let effectTimeColumn = this.findObject(this.carMonthPayFormOption.column, 'effectTime');
        if (row.carStatus == 5) {
          effectTimeColumn.disabled = true;
        } else {
          effectTimeColumn.disabled = true;
        }
        console.log(effectTimeColumn);
      }
      if (this.operateType === 0) {
        this.payWatchOpen = false;
        this.payFormTitle = '付款';
        column.disabled = true;
        this.payDisabled = true;
        feeRuleIdColumn.disabled = true;
        discountRuleIdColumn.disabled = true;
        feeRuleIdColumn.display = false;
        discountRuleIdColumn.display = false;
      this.findObject(this.carMonthPayFormOption.column, 'cycleNum').disabled = true;
      this.findObject(this.carMonthPayFormOption.column, 'discountRuleId').disabled = true;
      } else {
        this.payFormTitle = '续约';
        this.payWatchOpen = true;
        column.disabled = false;
        feeRuleIdColumn.disabled = false;
        discountRuleIdColumn.disabled = false;
        this.payDisabled = false;
        feeRuleIdColumn.display = true;
        discountRuleIdColumn.display = true;
      this.findObject(this.carMonthPayFormOption.column, 'cycleNum').disabled = false;
      this.findObject(this.carMonthPayFormOption.column, 'discountRuleId').disabled = false;
      }
      getDictionary('car_month_package').then((res) => {
        column.dicData = res.data;
      });
      let self = this;
      this.carMonthCardPayForm.id = row.id;
      this.findObject(this.carMonthPayFormOption.column, 'effectTime').disabled = true;
      getPayTypeListforSpaceId({ spaceId: row.spaceId }).then((res) => {
        this.payTypeList = res.data;
        if(manageType){
          this.setOptionColumn(this.carMonthPayFormOption,false);
          setTimeout(()=>{
            this.getNormalInfoDetail(feeRuleIdColumn,operateType,row);
          })
        }else{
          this.setOptionColumn(this.carMonthPayFormOption,true);
          setTimeout(()=>{
              this.getPayInfoDetail(feeRuleIdColumn,operateType,row);
          })
        }
      });
    },
    setOptionColumn(option,boolean){
      this.findObject(option.column, 'cycleNum').display = boolean;
      this.findObject(option.column, 'effectTime').display = boolean;
      this.findObject(option.column, 'expiredTime').display = boolean;
      this.findObject(option.column, 'feeRuleId').display = boolean;
      this.findObject(option.column, 'discountRuleId').display = boolean;
      this.findObject(option.column, 'shouldAmount').display = boolean;
      this.findObject(option.column, 'discountAmount').display = boolean;
      this.findObject(option.column, 'roomName').display = boolean;
      this.findObject(option.column, 'isMainCar').display = boolean;
      this.findObject(option.column, 'carManageType').display = boolean;
      this.findObject(option.column, 'bigOrSmallCar').display = boolean;
      this.findObject(option.column, 'parkingSpaceNames').display = boolean;
      this.findObject(option.column, 'description').display = !boolean;
      this.findObject(option.column, 'balance').display = !boolean;

      option = this._.cloneDeep(option);
    },
    getNormalInfoDetail(feeRuleIdColumn,operateType,row){
      let self = this;
getManageDetail({ id: row.id, operateType: operateType }).then(({ data }) => {
          this.carMonthCardPayForm = {};
          this.carMonthCardPayForm.expiredTime = '';
          this.carMonthCardPayForm = data;
          this.carMonthCardPayForm.payType = '';
          this.carMonthCardPayForm.cycleNum = '';
          this.carMonthCardPayForm.discountRuleId = data.discountRuleId;
          this.carMonthCardPayForm.carManageType = data.carManageType+'';
          this.carMonthCardPayForm.bigOrSmallCar = data.bigOrSmallCar+'';
          this.carMonthCardPayForm.isMainCar = data.isMainCar+'';
          //收费规则
          if (
            data.communityId + '' &&
            data.communityId + '' !== 'null' &&
            data.communityId + '' !== '-1'
          ) {
          } else {
            self.buildingList = [];
            self.targetList = [];
            self.carMonthCardPayForm.buildingId = '';
            self.carMonthCardPayForm.targetId = '';
          }
          this.carMonthCardPayForm.operatorType = operateType;
          this.carMonthCardPayForm.areaId = row.areaId;
          self.showMonthCarPayFlag = true;
        });
    },
    getPayInfoDetail(feeRuleIdColumn,operateType,row){
      let self = this;
getMonthCarFeeInFo({ id: row.id, operateType: operateType }).then(({ data }) => {
          this.carMonthCardPayForm = {};
          this.carMonthCardPayForm.expiredTime = '';
          this.carMonthCardPayForm = data;
          this.carMonthCardPayForm.payType = '';
          this.carMonthCardPayForm.cycleNum = data.cycleNum;
          this.carMonthCardPayForm.discountRuleId = data.discountRuleId;
          this.carMonthCardPayForm.carManageType = data.carManageType+'';
          this.carMonthCardPayForm.bigOrSmallCar = data.bigOrSmallCar+'';
          this.carMonthCardPayForm.isMainCar = data.isMainCar+'';
          //收费规则
          getCarRuleList(
            Object.assign({
              spaceId:row.spaceId,packageType:row.carManageType,
            })
          ).then(({ data }) => {
            // feeRuleIdColumn.dicData = data;
            self.ruleList = data;
          });
          this.carMonthCardPayForm.feeRuleId = data.feeRuleId;
          //优惠规则
          self.getCycleNumList();
          getCarRuleDiscountListNew({
            spaceId: self.carMonthCardPayForm.spaceId,
            payPeriods: self.carMonthCardPayForm.cycleNum,

        carFeeRuleId: self.carMonthCardPayForm.feeRuleId,
          }).then(({ data }) => {
            self.discountRuleList = data;
          });

          if (
            data.communityId + '' &&
            data.communityId + '' !== 'null' &&
            data.communityId + '' !== '-1'
          ) {
          } else {
            self.buildingList = [];
            self.targetList = [];
            self.carMonthCardPayForm.buildingId = '';
            self.carMonthCardPayForm.targetId = '';
          }
          this.carMonthCardPayForm.operatorType = operateType;
          this.carMonthCardPayForm.areaId = row.areaId;
          self.showMonthCarPayFlag = true;
        });
    },
    selectTempStopUnPayList(spaceId, carNo) {
      // 查询临停欠费记录
      getListTempStopUnPayList({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
        ({ data }) => {
          this.unPayData = data;
        }
      );
      this.tempStopUnPayDialogFlag = true;
    },
    carNohandleBlur() {
      if (this.vdui.isNotEmpty(this.form.carNo)) {
        if (this.vdui.isNotEmpty(this.form.spaceId)) {
          let backAmountTemp = 0;
          this.form.customerPhone = '';
          this.form.customerName = '';
          this.form.lotNo = '';
          this.form.areaName = '';
          this.form.areaId = '';
          //查询欠费
          loadCarPayBackAmount({ communityId: this.form.spaceId, carNo: this.form.carNo }).then(
            ({ data }) => {
              backAmountTemp = Number(data.carPayBackAmount);
              //  start-----getcarMonthLastEndTime
              getcarMonthLastEndTime({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
                ({ data }) => {
                  if (this.vdui.isNotEmpty(data)) {
                    this.form.lastEndTime = data.expiredTime;
                    this.form.effectTime = data.newStartTime + ' 00:00:00';
                    this.form.carType = data.carType;
                    if (this.vdui.isNotEmpty(data.regions)) {
                      this.form.regions = data.regions;
                    }
                    this.form.ruleId = data.ruleId;
                    this.form.backAmount = backAmountTemp;
                  } else {
                    let spaceIdTemp = this.form.spaceId;
                    let carNoTemp = this.form.carNo;
                    //若没查到则清空表单
                    this.emptyForm();
                    if (this.vdui.isEmpty(this.form.regions)) {
                      this.form.regions = this.regionFirstIdTemp;
                    }
                    if (backAmountTemp > 0) {
                      this.form.backAmount = backAmountTemp;
                    }
                    this.form.spaceId = spaceIdTemp;
                    this.form.carNo = carNoTemp;
                    this.form.effectTime = this.getInitData();
                  }
                }
              );
              //  end-----getcarMonthLastEndTime
            }
          );
        } else {
          this.$message.error('请先选择车场！');
          this.form.carNo = '';
        }
      } else {
        let spaceIdTemp = this.form.spaceId;
        this.emptyForm();
        this.form.spaceId = spaceIdTemp;
        this.form.effectTime = this.getInitData();
      }
    },

    selectSpace() {
      // l临时变量
      let spaceIdTempOne = this.form.spaceId;
      this.emptyBasePerson();
      this.emptyForm();
      this.form.spaceId = spaceIdTempOne;
      const feeRuleIdColumn = this.findObject(this.option.column, 'ruleId');
      if (this.vdui.isNotEmpty(this.form.spaceId)) {
        if (this.form.effectTime != '') {
          feeRuleIdColumn.disabled = false;
        } else {
          this.form.ruleId = '';
          feeRuleIdColumn.disabled = true;
        }
        monthChargeRuleList(Object.assign({ spaceId: this.form.spaceId })).then(({ data }) => {
          if (data.length == 0) {
            this.$message.error('该车场下未查询到月卡车收费规则！');
          }
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
        });
      }
    },
    //初始化化应收金额
    initShoudMoney() {
      if (this.vdui.isNotEmpty(this.form.cycleNum)) {
        if (this.vdui.isEmpty(this.form.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.form.ruleId,
          cycleNum: this.form.cycleNum,
          startTime: this.form.effectTime,
          backAmount: this.form.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          if (this.form.carClass == 2) {
            this.form.shouldAmount = 0;
            this.form.payMoney = 0;
          } else {
            this.form.shouldAmount = data.shouldAmount;
            this.form.payMoney = data.payAmount;
          }
          this.form.expiredTime = data.expiredTime + ' 23:59:59';
        });
      } else {
        if (!this.form.shouldAmount) {
          this.form.shouldAmount = 0;
        }
        if (!this.form.payMoney) {
          this.form.payMoney = 0;
        }
        return;
        // this.form.shouldAmount = 0;
      }
    },
    //获取区域节点数据
    getAreNodeList(parentId) {
      this.form.regions = '';
      nodeTreeByParentId(parentId).then((res) => {
        const regionsColumn = this.findObject(this.option.column, 'regions');
        if (this.operateType === 'add') {
          this.form.regionId = '';
        }
        regionsColumn.dicData = res.data;
        if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(regionsColumn.dicData)) {
          if (this.addFlag) {
            this.form.regions = regionsColumn.dicData[0].id;
            // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
            this.regionFirstIdTemp = regionsColumn.dicData[0].id;
          } else {
            this.form.regions = '';
          }
        }
      });
    },
    //查询车牌号
    queryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({ communityId: this.form.spaceId, searchContent: qs }).then(
        ({ data }) => {
          if (this.vdui.isEmpty(data)) {
            cb([]);
            if (this.vdui.isNotEmpty(this.form.spaceId)) {
              this.$message.info('没有匹配到车辆信息！');
              this.form.carNo = '';
            }
          } else {
            this._.forEach(data, (item) => {
              item.value = item.carNo;
            });
            cb(data);
          }
        }
      );
    },
    //选择车牌号
    selectCarPayCarNo(item) {
      this.form.carNo = item.carNo;
      this.form.customerPhone = item.customerPhone;
      this.form.customerId = item.customerId;
      this.form.customerName = item.customerName;
      this.form.lotNo = item.lotNo;
      this.form.areaName = item.areaName;
      this.form.areaId = item.areaId;
    },
    //选择车牌号
    openCarMonthDeleteDialog(row) {
      if (row.carStatus != 5) {
        this.$message.warning('请选择一条[已过期]数据进行操作');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeMainCar({ id: row.id });
        })
        .then(() => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
        });
    },
    //月卡车修改
    openCarMonthEditDialog(form, done) {
      this.editWatchOpen = false;
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthEditOption.column, 'regions');
        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      const cycleNumColumn = this.findObject(this.carMonthEditOption.column, 'cycleNum');
      getDictionary('car_month_package').then((res) => {
        cycleNumColumn.dicData = res.data;
      });
      const carTypeColumn = this.findObject(this.carMonthEditOption.column, 'carType');
      getDictionary('car_type_v2').then((res) => {
        carTypeColumn.dicData = res.data;
      });
      const carCategoryColumn = this.findObject(this.carMonthEditOption.column, 'carCategory');
      getDictionary('car_category_v2').then((res) => {
        carCategoryColumn.dicData = res.data;
      });
      let chargeRuleId = this.carMonthEditForm.ruleId;
      if (this.carMonthEditForm.ruleId) {
        if (this.carMonthEditForm.ruleId.id) {
          chargeRuleId = this.carMonthEditForm.ruleId.id;
        }
      }
      if (chargeRuleId == 'Invalid Date') {
        chargeRuleId = '';
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        chargeRuleId = '';
      }
      carMonthRuleV2({
        spaceId: this.carMonthEditForm.spaceId,
        payPeriods: this.carMonthEditForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthEditForm.discountId = data[0].id;
        } else {
          this.carMonthEditForm.discountId = '';
        }
      });
      getManageDetail({ id: form.id }).then(({ data }) => {
        this.carMonthEditForm = data;
        this.carMonthEditForm.effectTime = dayjs(data.effectTime).format('YYYY-MM-DD HH:mm:ss');
        this.carMonthEditForm.cycleNum = data.cycleNum;
        this.carMonthEditForm.discountId = data.discountId;
        this.effectTimeTemp = this.carMonthEditForm.effectTime;
        this.expiredTimeTemp = this.carMonthEditForm.expiredTime;
        this.carMonthEditShowDialogFlag = true;
        this.editWatchOpen = true;
      });
    },
    //月卡车查看详情
    openCarMonthViewDialog(form, done) {
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthViewOption.column, 'regions');
        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      // const cycleNumColumn = this.findObject(this.carMonthViewOption.column, 'cycleNum');
      // getDictionary('car_month_package').then(res => {
      //   cycleNumColumn.dicData = res.data;
      // });
      const carTypeColumn = this.findObject(this.carMonthViewOption.column, 'carType');
      getDictionary('car_type_v2').then((res) => {
        carTypeColumn.dicData = res.data;
      });
      const carCategoryColumn = this.findObject(this.carMonthViewOption.column, 'carCategory');
      getDictionary('car_category_v2').then((res) => {
        carCategoryColumn.dicData = res.data;
      });
      getManageDetail({ id: form.id }).then(({ data }) => {
        this.carMonthViewForm = data;
        this.carMonthViewForm.effectTime = dayjs(data.effectTime).format('YYYY-MM-DD HH:mm:ss');
        this.carMonthViewForm.cycleNum = data.cycleNum;
        this.carMonthViewForm.carType = data.carType;
        this.carMonthViewForm.carCategory = data.carCategory;
        this.effectTimeTemp = this.carMonthViewForm.effectTime;
        this.expiredTimeTemp = this.carMonthViewForm.expiredTime;
      });
      getDetailAndOperate({ id: form.id }).then(({ data }) => {
        this.carMonthViewForm.info = data.carMonthLogList;
      });
      this.carMonthViewShowDialogFlag = true;
    },
    //月卡车修改保存
    carMonthEditSubmit(row, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      if (row.ruleId.id) {
        row.ruleId = row.ruleId.id;
      }
      if (row.discountId) {
        if (row.discountId.id) {
          row.discountId = row.discountId.id;
        }
      }
      row.effectTime = dayjs(row.effectTime).format('YYYY-MM-DD HH:mm:ss');
      row.expiredTime = dayjs(row.expiredTime).format('YYYY-MM-DD HH:mm:ss');
      modifyCarMonth(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.quitCarMonthEditDialog();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },

    quitCarMonthEditDialog(form, done) {
      this.carMonthEditShowDialogFlag = false;
      this.editWatchOpen = false;
      this.$refs.carMonthEditFormRef.resetForm();
    },
    quitCarMonthReviewDialog(form, done) {
      this.carMonthReviewShowDialogFlag = false;
      this.reviewWatchOpen = false;
      this.$refs.carMonthReviewFormRef.resetForm();
    },
    quitCarMonthViewDialog(form, done) {
      this.carMonthViewShowDialogFlag = false;
      this.$refs.carMonthViewFormRef.resetForm();
    },
    //审核通过
    carMonthReviewSubmit(form, done) {
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          if (form.discountId) {
            if (form.discountId.id) {
              form.discountId = form.discountId.id;
            }
          }
          form.effectTime = dayjs(form.effectTime).format('YYYY-MM-DD HH:mm:ss');
          form.expiredTime = dayjs(form.expiredTime).format('YYYY-MM-DD HH:mm:ss');
          if (form.effectTime == 'Invalid Date' || JSON.stringify(form.effectTime) === '{}') {
            return;
          }
          if (form.expiredTime == 'Invalid Date' || JSON.stringify(form.expiredTime) === '{}') {
            return;
          }
          auditCarMonth(form).then(
            () => {
              done();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              this.anewOnLoad();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    //月卡车牌变更
    openCarMonthChangeDialog(form, done) {
      if (this.selectionList.length==0||this.selectionList.length>1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      this.carMonthChangeForm = this.selectionList[0];
      console.log("openCarMonthChangeDialog=============>",this.selectionList[0]);
      this.carMonthChangeForm.newCarNo = '';
      this.carMonthChangeForm.carManageType = this.selectionList[0].carManageType + '';
      this.carMonthChangeForm.bigOrSmallCar = this.selectionList[0].bigOrSmallCar + '';
      this.carMonthChangeForm.regions = this.selectionList[0].regionIds.split(',');
      this.carMonthChangeForm.newBigOrSmallCar = '';
      this.getRegion(this.carMonthChangeForm.spaceId);

          this.findObject(this.carMonthChangeOption.column, 'isMainCar').display=true;
          this.findObject(this.carMonthChangeOption.column, 'newBigOrSmallCar').display=true;
          this.findObject(this.carMonthChangeOption.column, 'bigOrSmallCar').display=true;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').label='关联主车';
        if(this.carMonthChangeForm.carManageType==4||this.carMonthChangeForm.carManageType==3){
          this.findObject(this.carMonthChangeOption.column, 'parkingSpaceNames').display=false;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').display=true;
          this.findObject(this.carMonthChangeOption.column, 'isMainCar').display=false;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').label='关联车辆';
        }
        if(this.carMonthChangeForm.isMainCar==0&&this.carMonthChangeForm.carManageType==1){
          this.findObject(this.carMonthChangeOption.column, 'parkingSpaceNames').display=false;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').display=true;
        }
        if(this.carMonthChangeForm.isMainCar==1&&this.carMonthChangeForm.carManageType==1){
          this.findObject(this.carMonthChangeOption.column, 'parkingSpaceNames').display=true;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').display=false;
        }

        if(this.carMonthChangeForm.carManageType==2){
          this.findObject(this.carMonthChangeOption.column, 'newBigOrSmallCar').display=false;
          this.findObject(this.carMonthChangeOption.column, 'bigOrSmallCar').display=false;
          this.findObject(this.carMonthChangeOption.column, 'parkingSpaceNames').display=true;
          this.findObject(this.carMonthChangeOption.column, 'mainPlateNumber').display=false;
        }
        this.carMonthChangeOption = this._.cloneDeep(this.carMonthChangeOption);
      this.carMonthChangeShowDialogFlag = true;
    },
    quitCarMonthChangeDialog(form, done) {
      this.carMonthChangeShowDialogFlag = false;
      this.$refs.carMonthChangeFormRef.resetForm();
    },
    carMonthChangeSubmit(form, done) {
      this.$refs.carMonthChangeFormRef.validate((valid) => {
        if (valid) {
          form.operateType = 3;
          if (form.carNo === form.newCarNo) {
            this.$message.success('输入新车牌号与修改前一样!');
            this.carMonthChangeForm.newCarNo = ' ';
            done();
            return;
          }
          form.newCarNo = form.newCarNo.trim();
          plateNumberChange(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthChangeShowDialogFlag = false;
              this.$refs.carMonthChangeFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
              done();
            }
          );
        }
      });
    },
    //月卡车退费
    openCarMonthRefundDialog(form, done) {
      if (this.selectionList[0].carClass == 2) {
        this.$message.warning('免费车不允许退款，请重新操作！');
        return;
      }
      if (this.selectionList.length !== 1 || this.selectionList[0].carStatus !== 3) {
        this.$message.warning('请选择一条[正常]数据进行操作！');
        return;
      }
      getDetail({id: this.selectionList[0].id}).then(({data}) => {
        this.carMonthRefundForm = data;
        this.carMonthRefundShowDialogFlag = true;
        // this.carMonthRefundForm.expiredTime = day1.toISOString().slice(0, 10) + ' 23:59:59';
        this.carMonthRefundForm.expiredTime = data.expiredTime;
        this.carMonthRefundForm.returnMoney = 1;
      });
    },
    quitCarMonthRefundDialog(form, done, loading) {
      this.carMonthRefundShowDialogFlag = false;
      this.refundCheckReturnMoney = true;
      this.refundCheckexpiredTime = true;
      this.$refs.carMonthRefundFormRef.resetForm();
    },
    carMonthRefundSubmit(form, done) {
      form.operateType = 4;
      update(form).then(
        () => {
          this.$message.success('操作成功!');
          done();
          this.carMonthRefundShowDialogFlag = false;
          this.$refs.carMonthRefundFormRef.resetForm();
          this.anewOnLoad();
        },
        (error) => {
          console.log(error);
          done();
        }
      );
    },
    rowSave(row, loading, done) {

      addRenior(row).then(
        () => {
          this.$message.success('操作成功!');
          //清空上一表单数据
          let spaceIdTemp = this.form.spaceId;
          //this.form.regions = this.regionFirstIdTemp;
          this.form.regions = '';
          this.form.effectTime = this.getInitData();
          this.emptyForm();
          // 清空车主基本信息
          this.emptyBasePerson();
          this.form.spaceId = spaceIdTemp;
          this.onLoad();
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    //自定义清空表单
    emptyForm() {
      this.form.spaceId = '';
      this.form.carNo = '';
      this.form.carClass = 1;
      this.form.carType = '';
      this.form.lastEndTime = '';
      this.form.backAmount = 0;
      this.form.ruleId = '';
      this.form.cycleNum = '';
      this.form.expiredTime = '';
      this.form.shouldAmount = 0;
      this.form.payMoney = 0;
      this.form.regions = '';
      this.form.imgUrl = '';
      this.form.effectTime = this.getInitData();
    },
    // 新增后，清空车主基本信息
    emptyBasePerson() {
      this.form.customerName = '';
      this.form.customerPhone = '';
      this.form.areaId = '';
      this.form.areaName = '';
      this.form.lotNo = '';
    },
    rowUpdate(row, index, loading, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          loading();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    searchReset() {
      this.searchForm = {};

      this.searchForm.spaceId = this.tempSpaceId;
      this.query.spaceId = this.tempSpaceId;
      this.query .parkingSpaceNames= "";
      this.query .carManageType="";
      this.query .plateNumber= "";
      this.query .personName= "";
      this.query .personPhone= "";
      this.query .roomName= "";
      this.query .carStatus= "";
      this.query .remainDays= "";
      this.query .expiredTimeEnd= "";
      this.query .expiredTimeStart= "";
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query .spaceId= params.spaceId;
      this.query .parkingSpaceNames= params.parkingSpaceNames;
      this.query .carManageType= params.carManageType;
      this.query .plateNumber= params.plateNumber;
      this.query .personName= params.personName;
      this.query .personPhone= params.personPhone;
      this.query .roomName= params.roomName;
      this.query .carStatus= params.carStatus;
      this.query .remainDays= params.remainDays;

      this.page.currentPage = 1;
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      this.onLoad();
      done();
    },
    anewOnLoad() {
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (!this.query.spaceId) {
        this.query.spaceId = this.tempSpaceId;
      }
      this.onLoad();
    },
    selectionChange(list) {
      console.log('selectionChange(list) ===>', list);
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      // this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    getInitData() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (strDate < 10) {
        strDate = '0' + strDate;
      }
      var currentdate = year + '-' + month + '-' + strDate + ' 00:00:00';
      return currentdate;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;

      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      if (this.spaceList.length > 0) {
        this.tempSpaceId = this.query.spaceId;
        getCarManageStatusCount(this.query).then(res=>{
          this.statusCountNew = res.data
        })
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
        ).then(({ data }) => {
          this.page.total = data.total;
          data.records.forEach(ele=>{
            ele.carManageType = ele.carManageType+'';
            if(ele.isMainCar==-1){
              ele.isMainCar='';
            }
            if(ele.carManageType==3||ele.carManageType==4){
              ele.expiredTime='';
              ele.remainDays='';
            }
          });
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.spaceId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    //打开导出弹框
    openExportExcelDialog() {
      this.exportExcelFlag = true;
      this.$refs.exportExcelFormRef.resetForm();
    },
    //按条件导出
    exportExcel(form, done) {
      var values = { ...form };
      const { dateStartRange, dateEndRange } = form;
      if (dateStartRange) {
        values = {
          ...form,
          effectTimeStart: dateStartRange[0],
          effectTimeEnd: dateStartRange[1],
        };
        values.dateStartRange = null;
        this.form.dateStartRange = null;
      }
      if (dateEndRange) {
        values = { ...form, expiredTimeStart: dateEndRange[0], expiredTimeEnd: dateEndRange[1] };
        values.outTime = null;
        this.form.dateEndRange = null;
      }
      this.$refs.carMonthExport.carMonthExportExcel(values);
      done();
    },
    uploadBefore(file, done, loading) {
      // console.log(file.name.split('.'));
      let len = file.name.split('.').length;
      // console.log(file.name.split('.')[len-1]);
      console.log(
        file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
      );
      console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },
  },
};
</script>

<style lang="scss">
#carMonthManage20220222 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
